<script setup lang="ts">
import Icon from "@/core/components/icon/Icon.vue";
</script>

<template>
  <Icon name="mdi-plus-box-multiple" />
</template>

<style scoped>

</style>
